import { PublicProject } from '../projects';
import { QueryResult } from 'react-query';
import { ImpactType } from '../impact';

export enum ProfileSizes {
  XLARGE = 'XLARGE',
  LARGE = 'LARGE',
  DEFAULT = 'DEFAULT',
  SMALL = 'SMALL',
}

export type UserImpactAggregates = Record<
  Exclude<ImpactType, ImpactType.TREES>,
  QueryResult<AggregateOfImpactByProject<Exclude<ImpactType, ImpactType.TREES>>>
>;

export type AggregateOfImpactByProject<T extends Exclude<ImpactType, ImpactType.TREES>> = {
  userId: string;
  unallocatedCountFromLegacyProjects: number;
  projects: ProjectWithImpactQuantity<T>[];
};

export type ProjectWithImpactQuantity<T extends Exclude<ImpactType, ImpactType.TREES>> = {
  [ImpactType.CARBON_OFFSETS]: PublicProject;
  [ImpactType.CARBON_REMOVAL]: PublicProject;
  [ImpactType.HABITAT_RESTORATION]: PublicProject;
}[T] & {
  impactQuantity: number;
};
